import React, { useEffect, useMemo, useRef, useState } from "react";
import CustomIcons from "../../icons/kIcons.component";
import Loader from "../../loader/loader";
import CheckBox from "../../inputs/checkbox";
import "./compDirectory.style.css";
import SearchButton from "../../inputs/searchButton";
import MoreDetails from "./moreDetails/moreDetails";
import Pagination from "./companyPagination";
import BreadCrumpBack from "../../navigator/back";

export default function CommonCompanyDirectory(props) {
  const [pageSize, setPageSize] = useState(props.perPage || 6);
  const [currentPage, setCurrentPage] = useState(1);
  const [showTopFilters, setShowTopFilters] = useState(false);
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);

  const mainData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    const filtered = props.showStatus7
      ? props.data || []
      : (props.data || []).filter(item => item.application_status !== 7);
    return filtered.slice(firstPageIndex, lastPageIndex);
  }, [props.data, currentPage, pageSize, props.showStatus7]);

  const [domain, setDomain] = useState(props.domain);
  const [openView, setOpenView] = useState(false);
  const [activeData, setActiveData] = useState({});
  const myRef = useRef(null);
  const searchChange = (e) => {
    const v = e.target.value;
    props.setSearch(v);
    props.setQsearch(v);
  };
  const submitSearch = () => {
    // props.searchCompanies();
    props.setQsearch(props.search);
  };
  const clearSearch = () => {
    props.setSearch("");
    props.setQsearch("");

    // props.searchCompanies();
    // submitSearch()
  };
  const handleNav = (d, a) => {
    // //console.log(d.startsWith("https"))
    if (d.startsWith("https://")) {
      window.open(`${d}`, "_blank");
    } else {
      window.open(`https://${d}`, "_blank");
    }
  };
  const handleViewDetails = (item) => {
    setOpenView(true);
    setActiveData(item);
  };
  const handleViewClose = () => {
    setOpenView(false);
    setActiveData({});
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    myRef.current.scrollIntoView();
  };
  // Responsive page size: 8 on large screens, otherwise keep provided perPage
  useEffect(() => {
    const computeSize = () => {
      const isLarge = typeof window !== 'undefined' && window.innerWidth >= 1025;
      setPageSize(isLarge ? 6 : (props.perPage || 6));
    };
    computeSize();
    window.addEventListener('resize', computeSize);
    return () => window.removeEventListener('resize', computeSize);
  }, [props.perPage]);
  useEffect(() => {
    setDomain(props.domain);
  }, [props.domain, props.key]);
  return (
    <div ref={myRef}>
      <div className="">
        <Loader open={props.isActive} />
        <div>
          <div className="dash-banner">
            <div className="tit-txt">{props.title}  </div>
          </div>
        </div>
        <BreadCrumpBack />

        <div className="comp-layout-con">
          {/* <CustomIcons iconName="edit" iconClass=""/> */}
          {/* Top filter bar */}
          <div className="top-filter-wrap">
            <div className="filter-bar-actions">
              <button
                className="filter-toggle-btn"
                onClick={() => setShowTopFilters((s) => !s)}
              >
                <CustomIcons iconName="filter" /> Filters by Domain
              </button>
              <div className="comp-search-box" style={{ flex: 1, marginLeft: 12 }}>
                <SearchButton
                  type="text"
                  onChange={searchChange}
                  clearSearch={clearSearch}
                  value={props.search}
                  placeholder={"Search by Company"}
                  showSearchIcon={true}
                  onSearch={submitSearch}
                />
              </div>
            </div>
            <div className={`filter-bar ${showTopFilters ? 'open' : ''}`}>
              <div className="filter-bar-inner">
                {domain?.map((item) => (
                  <CheckBox
                    key={item.id || item.domain_name}
                    className="domaincheck"
                    label={item.domain_name}
                    checked={item.checked ? true : false}
                    onChange={(e) => {
                      props.FilterChange(e, item);
                    }}
                  />
                ))}
                <div className="com-sel-filters" style={{ paddingTop: 0 }}>
                  {props.domain.map((item) => (
                    item.checked && (
                      <div key={item.id || item.domain_name} className="comp-filter-item">
                        <div className="comp-filter-item-label">
                          {item.domain_name}
                        </div>
                        <div
                          className="filter-clearButton-cont"
                          onClick={() => props.closeFilter(item)}
                        >
                          <CustomIcons
                            iconName="clearInput"
                            iconClass={"filter-clear-button"}
                          />
                        </div>
                      </div>
                    )
                  ))}
                </div>
                <div className="filter-bar-footer">
                  <button
                    type="button"
                    className="clear-filter-btn"
                    onClick={() => { props.clearFilter(); setShowTopFilters(false); }}
                  >
                    <CustomIcons iconName="clearInput" />
                    Clear Filter
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Listing */}
          <div className="comp-outer-cont">
            <div className="com-dir-cont">
              <div className="comp-list-con">
                {mainData && mainData.length !== 0 ? (
                  <>
                    {mainData?.map((item) => (
                      item?.company_name !== "NDF10display" && (
                        <div key={item.id || item.company_name} className="comp-list-item-cont">
                          <div className="comp-list-item d-flex flex-column justify-content-between">
                            <div>
                              {/* Top Header Section */}
                              <div className="d-flex align-items-start gap-3 mb-3">
                                {item?.logo ? (
                                  <div className="comp-item-logo">
                                    <img
                                      className="comp-item-img-logo"
                                      alt=""
                                      src={`${result}/${item?.logo}`}
                                    />
                                  </div>
                                ) : (
                                  <div className="comp-item-logo placeholder">
                                    {item?.company_name?.substring(0, 1)?.toUpperCase()}
                                  </div>
                                )}
                                <div className="comp-item-header-info">
                                  <div className="comp-item-comp-title mb-1">
                                    {item.company_name
                                      ? item.company_name.charAt(0).toUpperCase() + item.company_name.slice(1)
                                      : ""}
                                  </div>
                                  <div className="comp-item-person-name">
                                    <i className="fa fa-user-circle mr-1" style={{ opacity: 0.7 }}></i>
                                    {item.person_name}
                                  </div>
                                </div>
                              </div>

                              {/* Domain Chips */}
                              {(item.any_other_domain || (item.domain_types && item.domain_types.length > 0)) && (
                                <div className="comp-item-dom-cont mb-3">
                                  {item.any_other_domain && (
                                    <span className="chip">#{item.any_other_domain}</span>
                                  )}
                                  {item.domain_types?.map((dom, i) => (
                                    <span key={`${dom.domain_name}-${i}`} className="chip">#{dom.domain_name}</span>
                                  ))}
                                </div>
                              )}

                              {/* Contact Information List */}
                              <div className="comp-item-contact-list mb-3">
                                <div className="contact-detail-item">
                                  <i className="fa fa-envelope contact-icon"></i>
                                  <span className="contact-text text-break">{item.email}</span>
                                </div>

                                {item.ex_man_power && item.ex_man_power !== "null" && (
                                  <div className="contact-detail-item">
                                    <i className="fa fa-users contact-icon"></i>
                                    <span className="contact-text">{item.ex_man_power} Employees</span>
                                  </div>
                                )}

                                {item?.site_link && (
                                  <div className="contact-detail-item clickable" onClick={() => handleNav(item?.site_link)}>
                                    <i className="fa fa-globe contact-icon"></i>
                                    <span className="contact-text text-primary text-decoration-underline">{item?.site_link}</span>
                                  </div>
                                )}
                              </div>

                              {/* Product Profile Section */}
                              {item.product_profiles && item.product_profiles.length > 0 && (
                                <div className="comp-item-product-prof-cont">
                                  <span className="product-prof-label">Product Profile</span>
                                  <div className="product-prof-list mt-1">
                                    {item.product_profiles.slice(0, 2).map((produ, index) => (
                                      <div key={produ.id || index} className="product-prof-item">
                                        <i className="fa fa-cube mr-1 text-muted" style={{ fontSize: "11px" }}></i>
                                        {produ.product_name}
                                      </div>
                                    ))}
                                    {item.product_profiles.length > 2 && (
                                      <div className="product-prof-more">
                                        + {item.product_profiles.length - 2} more products
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>

                            {/* View Details Footer */}
                            <div className="comp-view-more-cont-new mt-3 pt-3 border-top d-flex justify-content-end">
                              <button
                                type="button"
                                className="btn btn-sm btn-light border text-primary px-3 py-2"
                                style={{
                                  borderRadius: "6px",
                                  fontWeight: "600",
                                  fontSize: "12px",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  transition: "all 0.2s ease-in-out"
                                }}
                                onClick={() => handleViewDetails(item)}
                              >
                                View Details <i className="fa fa-arrow-right" style={{ fontSize: "10px" }}></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      )
                    ))}
                  </>
                ) : (
                  <div className="no-data-found">No Results found</div>
                )}
              </div>
            </div>
          </div>
          <Pagination
            className="pagination-bar"
            currentPage={currentPage}
            totalCount={props.data.length}
            pageSize={pageSize}
            onPageChange={(page) => handlePageChange(page)}
          />
        </div>
      </div>
      <MoreDetails
        open={openView}
        data={activeData}
        handleClose={handleViewClose}
        india={props?.india}
      />
    </div>
  );
}
